/**
 * React Query configuration constants for subscription API hooks.
 * Centralizes cache timing, retry logic, and other query options
 * to ensure consistency across all subscription API files.
 */

// Stale time constants (how long data is considered fresh)
export const STALE_TIME = {
  /** 30 seconds - for frequently changing data like previews */
  SHORT: 30_000,
  /** 1 minute - for list data that may change */
  MEDIUM: 60_000,
  /** 5 minutes - for reference/static data like templates, filters, metrics */
  LONG: 300_000,
} as const;

// Cache time constants (how long inactive data stays in cache)
export const CACHE_TIME = {
  /** 5 minutes - default cache retention */
  DEFAULT: 300_000,
  /** 10 minutes - for very static data */
  LONG: 600_000,
} as const;

// Retry configuration
export const RETRY_COUNT = 1;

// Common query options for different use cases
export const QUERY_OPTIONS = {
  /** For list/table data that updates frequently */
  list: {
    staleTime: STALE_TIME.MEDIUM,
    retry: RETRY_COUNT,
  },
  /** For detail views */
  detail: {
    staleTime: STALE_TIME.MEDIUM,
    gcTime: CACHE_TIME.DEFAULT,
    retry: RETRY_COUNT,
    refetchOnWindowFocus: false,
  },
  /** For reference/lookup data (templates, filters, metrics) */
  reference: {
    staleTime: STALE_TIME.LONG,
    retry: RETRY_COUNT,
  },
  /** For preview data that changes based on form inputs */
  preview: {
    staleTime: STALE_TIME.SHORT,
    retry: RETRY_COUNT,
  },
} as const;
